<template lang="pug">
.header__banner
  .header__banner-wrapper.header__banner-wrapper--market
    img.header__banner-fullimage(src="~@/assets/img/header/banner/market/banner.png" alt="Новинка! Спортивное питание от Gorilla на маркетплейсах")
    a.header__banner-market-link.header__banner-market-link--wb(:href="wbUrl" target="_blank" rel="noopener noreferrer" aria-label="Купить на Wildberries")
    a.header__banner-market-link.header__banner-market-link--ozon(:href="ozonUrl" target="_blank" rel="noopener noreferrer" aria-label="Купить на OZON")
  //- Баннер «мармеладки» временно отключён — не удалять, при необходимости раскомментировать (и вернуть index 0 в ротацию ниже)
    .header__banner-wrapper.header__banner-wrapper--marmelade(v-show="activeIndex === 0" v-tap="showModal")
      .header__banner-content
        .header__banner-content-title {{ $t('header.banner.title') }}
          span {{ $t('header.banner.title_accent') }}
        .header__banner-content-text {{ $t('header.banner.text') }}
        .header__banner-marketplace
          img(src="~@/assets/img/header/banner/marmelade/wb.png" alt="wb")
          img(src="~@/assets/img/header/banner/marmelade/ozon.png" alt="ozon")
      .header__banner-image
        img(src="~@/assets/img/header/banner/marmelade/banner-product-mini.png")
</template>

<script>

export default {
  name: 'HeaderBanner',
  data () {
    return {
      wbUrl: 'https://www.wildberries.ru/seller/250051432?sort=popular&page=1&fbrand=312295560',
      ozonUrl: 'https://www.ozon.ru/seller/fahrenheit-nutrition-formula/brand/gorilla-ultimate-102077913/'
    }
  },
  methods: {
    showModal () {
      this.$modal.show('ModalBanner')
    }
  }
}
</script>
